import React from "react";
import OneVideo from "../OneVideo";
import CouponFileReader from "../CouponFileReader";
import SwiperFileReader from "../SwiperFileReader";
import SwiperDataFeedReader from "../SwiperDataFeedReader";
import clsx from "clsx";
import Hotels from "../Hotels";
import "./styles.scss";

const ProductPartial = (props) => {
  const { files, param } = props?.dataprop;
  const shouldRenderLink = !!files?.[0]?.link;
  const shouldRenderVideo = !!files?.[0]?.videoUrl;

  return param?.toLocaleLowerCase() === "charitum" ? (
    <Hotels />
  ) : (
    <div
      className={clsx("product-wrap swiper-listing-items", `product-${param}`)}
    >
      <div className="products-title">{param}</div>
      {shouldRenderVideo && (
        <div className="mp4-video">
          <div className="player-wrapper">
            <OneVideo
              video={{ videoUrl: files?.[0]?.videoUrl }}
              controls={false}
              loop={true}
              // currentVideoUrl={currentVideoUrl}
              // setCurrentVideoUrl={setCurrentVideoUrl}
              // handleVideoClick={handleVideoClick}
            />
            <div className="link-component flex-it flex-align-item-center flex-justify-center">
              {shouldRenderLink && (
                <a
                  className="checkout-btn"
                  target="_blank"
                  href={files?.[0]?.link}
                  rel="noreferrer"
                >
                  Link to {param}
                </a>
              )}
            </div>
          </div>
        </div>
      )}

      <>
        {/* <OuterVideo videoUrl={videoUrl} /> */}
        <CouponFileReader
          filename={`${param.toLocaleLowerCase()}-coupons.txt`}
          title={`Coupons:`}
          logo={files?.[0]?.couponLogo}
          bgColor={files?.[0]?.couponBgColor}
          theme={files?.[0]?.couponTheme}
          name={param}
        />
      </>

      <div className="product-list">
        {files?.map((file) => {
          return file?.fileType === "normal" ? (
            <SwiperFileReader
              key={file?.filename}
              filename={file?.filename}
              title={file?.title}
              logo={file?.logo}
              bgColor={file?.bgColor}
              theme={file?.theme}
              name={file?.name}
              preferredHeight={file?.preferredHeight}
              preferredWidth={file?.preferredWidth}
              website={file?.website}
              merchantId={file?.merchantId}
              isShareUrl={file?.isShareUrl}
            />
          ) : (
            <SwiperDataFeedReader
              key={file?.filename}
              filename={file?.filename}
              title={file?.title}
              logo={file?.logo}
              bgColor={file?.bgColor}
              theme={file?.theme}
              name={file?.name}
              preferredHeight={file?.preferredHeight}
              preferredWidth={file?.preferredWidth}
              website={file?.website}
              type={"listing"}
              dataFeedType="sharesale-type"
              merchantId={file?.merchantId}
              isShareUrl={file?.isShareUrl}
            />
          );
        })}

        {/*       
      {files?.map((file) => {
        return (
          <SwiperFileReader
            type={"listing"}
            key={file?.filename}
            filename={file?.filename}
            title={file?.title}
            logo={file?.logo}
            bgColor={file?.bgColor}
            theme={file?.theme}
            name={file?.name}
            preferredHeight={file?.preferredHeight}
            preferredWidth={file?.preferredWidth}
            website={file?.website}
          />
        );
      })} */}
      </div>
    </div>
  );
};

export default ProductPartial;
